"use strict";

exports.__esModule = true;
exports.isWithinSizeLimits = void 0;

var isWithinSizeLimits = function isWithinSizeLimits(file, limitInMegaBytes) {
  return file.size < limitInMegaBytes * 1000000;
};

exports.isWithinSizeLimits = isWithinSizeLimits;